import { render, staticRenderFns } from "./ULiveIcon.vue?vue&type=template&id=5468da86&scoped=true&"
var script = {}
import style0 from "./ULiveIcon.vue?vue&type=style&index=0&id=5468da86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5468da86",
  null
  
)

export default component.exports